<div class="wrapper">
  <div class="m-box">
    <h2>
      {{'appointments.gui.labels.HMO Clinic Price List' | translate}}
    </h2>

    <div style="display: flex; flex-direction: row;justify-content: center;">
      <button class="blue-btn" [ngClass]="hmo=='Leumit'?'btn-click':''" (click)="setHmo('Leumit')">לאומית</button>
      <button class="blue-btn" [ngClass]="hmo=='Meuhedet'?'btn-click':''" (click)="setHmo('Meuhedet')">מאוחדת</button>
      <button class="blue-btn" [ngClass]="hmo=='Macabi'?'btn-click':''" (click)="setHmo('Macabi')">מכבי</button>
      <button class="blue-btn" [ngClass]="hmo=='Clalit'?'btn-click':''" (click)="setHmo('Clalit')">כללית</button>
    </div>
    <div style="display: flex; flex-direction: row;justify-content: center;">
      <button class="blue-btn" *ngIf="hmo=='Clalit'" [ngClass]="insurance=='Platinum'?'btn-click':''"
        (click)="setInsurance('Platinum')">פלטינום</button>
      <button class="blue-btn" *ngIf="hmo=='Clalit'" [ngClass]="insurance=='Mushlam'?'btn-click':''"
        (click)="setInsurance('Mushlam')">מושלם</button>
      <button class="blue-btn" *ngIf="hmo=='Macabi'" [ngClass]="insurance=='Sheli'?'btn-click':''"
        (click)="setInsurance('Sheli')">שלי</button>
      <button class="blue-btn" *ngIf="hmo=='Macabi'" [ngClass]="insurance=='Zahav'?'btn-click':''"
        (click)="setInsurance('Zahav')">זהב</button>
      <button class="blue-btn" *ngIf="hmo=='Macabi'" [ngClass]="insurance=='Kesef'?'btn-click':''"
        (click)="setInsurance('Kesef')">כסף</button>
      <button class="blue-btn" *ngIf="hmo=='Macabi'" [ngClass]="insurance=='Basis'?'btn-click':''"
        (click)="setInsurance('Basis')"> בסיסי</button>
      <button class="blue-btn" *ngIf="hmo=='Meuhedet'" [ngClass]="insurance=='Adif'?'btn-click':''"
        (click)="setInsurance('Adif')"> עדיף</button>
      <button class="blue-btn" *ngIf="hmo=='Meuhedet'" [ngClass]="insurance=='C'?'btn-click':''"
        (click)="setInsurance('C')"> שיא</button>
      <button class="blue-btn" *ngIf="hmo == 'Leumit'" [ngClass]="insurance == 'Kesef' ? 'btn-click':''"
        (click)="setInsurance('Kesef')">כסף</button>
      <button class="blue-btn" *ngIf="hmo == 'Leumit'" [ngClass]="insurance == 'Zahav' ? 'btn-click':''"
        (click)="setInsurance('Zahav')">זהב</button>
    </div>
    <table *ngIf="hmo && insurance">
      <tr>
        <th>
          {{'billing.gui.labels.Exam Name' | translate}}
        </th>
        <th>
          {{ ls.isObgyn ? ('appointments.gui.labels.Singleton' | translate) : ('appointments.gui.labels.Price' |
          translate) }}
        </th>
        <th *ngIf="ls.isObgyn">
          {{'appointments.gui.labels.Twins' | translate}}
        </th>

      </tr>

      <tr [ngClass]="exam.isEditing? 'tr-isActive' : ''" *ngFor="let exam of exams">
        <!-- <td style="width: 17%;"><select class="t-select w100"  [(ngModel)]="exam.examType" [disabled]="!exam.isEditing">
            <option *ngFor="let type of getExamTypes()" [value]="type">
              {{ 'appointments.gui.exams.'+type | translate }}
            </option>
          </select></td> -->
        <td style="width: 17%;"><select class="t-select w100" [(ngModel)]="exam.examId" [disabled]="!exam.isEditing">
            <option *ngFor="let exam of examsSettings" [value]="exam.AutoIndex">
              {{exam.examName}}
            </option>
          </select>
        </td>
        <td>
          <input class="search-patient-field  menstural-field w" type="number" [(ngModel)]="exam.examPrice"
            [disabled]="!exam.isEditing">
        </td>
        <td *ngIf="ls.isObgyn">
          <input class="search-patient-field   menstural-field " type="number" [(ngModel)]="exam.examPriceTwins"
            [disabled]="!exam.isEditing">
        </td>
        <td>
          <button class="blue-btn" *ngIf="!exam.isEditing" (click)="editExam(exam)">
            {{'appointments.gui.buttons.Edit' | translate}}
          </button>
          <button class="orange-btn" *ngIf="exam.isEditing" (click)="saveChanges(exam)">
            {{'appointments.gui.buttons.Save' | translate}}
          </button>
          <button class="orange-btn" (click)="deletePrice(exam)">
            {{'appointments.gui.buttons.Delete' | translate}}
          </button>
        </td>
      </tr>
      <tr>
        <!-- <td><select class="t-select w100" [(ngModel)]="newExam.examType" >
                <option *ngFor="let type of getExamTypes()" [value]="type">
                  {{ 'appointments.gui.exams.'+type | translate }}
                </option>
              </select></td> -->
        <td style="width: 17%;"><select class="t-select w100" [(ngModel)]="newExam.examId">
            <option *ngFor="let exam of examsSettings" [value]="exam.AutoIndex">
              {{exam.examName}}
            </option>
          </select>
        </td>
        <td>
          <input type="number" min="0" class="search-patient-field  menstural-field " [(ngModel)]="newExam.examPrice">
        </td>
        <td *ngIf="ls.isObgyn">
          <input type="number" min="0" class="search-patient-field  menstural-field "
            [(ngModel)]="newExam.examPriceTwins">
        </td>
        <td>
          <button style="white-space: nowrap;" class="orange-btn" (click)="saveNewExam()">
            {{'appointments.gui.buttons.Save New' | translate}}
          </button>
        </td>
      </tr>
    </table>

  </div>
</div>